/* unplugin-vue-components disabled */import { render } from "./FocusComponent.vue?vue&type=template&id=ccaf0f04&scoped=true"
import script from "./FocusComponent.vue?vue&type=script&lang=js"
export * from "./FocusComponent.vue?vue&type=script&lang=js"

import "./FocusComponent.vue?vue&type=style&index=0&id=ccaf0f04&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccaf0f04"]])

export default __exports__